import React, { useEffect } from "react";
import { Route, RouteComponentProps, useHistory } from "react-router-dom";
import Header from "../Header/Header.component";
import Footer from "../Footer";
import { CRoutePaths } from "../../constants/CApp";
import { CLocalStorage } from "../../constants/CLocalStorage";
import { API_SSO } from "../../api/ssoapi/SSOapi";
import { ISSOUser, UpdateUser } from "../../slices/UserSlice";
import { useDispatch, useSelector } from "react-redux";
import { UseSessionManager } from "../../browser/session/SessionManager";
import Sidebar from "../Mangement/notificationPage/sidebar/Sidebar";
import { AppDispatch, RootState } from "../../redux-store/store";
import { NotificationActions } from "../../slices/NotificationSlice";
import {
  GetPartnerType,
  GetPartnerTypeForOPF,
} from "../../api/ssoapi/UserControlapi";
import { CAPPNames } from "../Constants/Application";

interface PrivateRouteProps {
  component: React.FC<RouteComponentProps>;
  path: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  path,
  component: Component,
  ...rest
}) => {
  // const [token, setToken] = useState("");
  // const isLoggedIn =  !!token;
  // console.log(token);

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(window.location.search);
  //   const oktaToken = searchParams.get('token');
  //   console.log(oktaToken);
  //   if (oktaToken) {
  //     setToken(oktaToken);
  //   }
  // }, []);

  const history = useHistory();
  const dispatch = useDispatch<AppDispatch>();

  const { user, switchRole, features, accessApplications } = useSelector(
    (state: RootState) => state.user
  );
  console.log(user, "user");

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    if (user != null) {
      if(accessApplications != null)
      {
        accessApplications?.map((access) => {
          if (access == CAPPNames.CCT) {
            dispatch(GetPartnerType(user.email));
          }
          if (access == CAPPNames.OPF) {
            dispatch(GetPartnerTypeForOPF(user.email));
          }
        });
      }
    }
  }, [user]);

  useEffect(() => {
    console.log("history.location.pathname", history.location.pathname);
    if (
      !features.userControl.viewUserControl &&
      history.location.pathname === CRoutePaths.UserControl
    ) {
      history.push(CRoutePaths.Notifications);
    }
  }, [features]);

  const getUser = async () => {
    const email = sessionStorage.getItem(CLocalStorage.Keys.Email);
    console.log(email);

    try {
      var res = await API_SSO.GetUser(email ? email : "");

      if (res.data?.status?.includes("SUC") && res.data?.data) {
        console.log("userrrr", res.data.data);
        dispatch(UpdateUser({ user: res.data.data }));
      }
    } catch (error) {
      console.error("Form validation error: ", error);
      history.replace(CRoutePaths.Login);
    }
  };

  return (
    <>
      <UseSessionManager />
      <Header
        isLogin={true}
        user={user}
        onClickChangePwd={() => {
          //setChanPwd(true);
        }}
      />

      <div className="main-container">
        {switchRole.accessRoles.length > 0 && <Sidebar />}
        <Route {...rest} render={(props) => <Component {...props} />} />
      </div>
      <Footer />
    </>
  );
};

export default PrivateRoute;
